module.exports = __webpack_public_path__ + "static/media/25GalleryPuppets.fbf012f9.jpeg";